import axios from 'axios'
import * as querystring from 'querystring'

import config from '../config/urlConfig'
import formatAxiosError from '../util/formatAxiosError'
import { TinTuc, Comment, DanhMuc, TinQuanTam, TinTucNew } from '../models'
import axiosOptions from '../const/axios-options'

export default class TinTucService {
  static getTinTucDetail(tieuDe) {
    let query = querystring.stringify({ url: tieuDe })
    return axios
      .get(`${config.app.api}/api/tintuc/detail?${query}`, axiosOptions)
      .then(response => {
        let comments = response.data.tinTuc.comment || []
        let tinLienQuan = response.data.tinLienQuan || []
        let tinTuc = response.data.tinTuc
        return {
          tinTuc: new TinTuc(tinTuc),
          comments: comments.map(c => new Comment(c)),
          tinLienQuan: tinLienQuan.map(tinTuc => new TinQuanTam(tinTuc)),
        }
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }
  /**xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx */

  static getList(
    danhMucId,
    page = 1,
    pageSize = 10
  ): Promise<{ danhSachTinTuc: TinTuc[]; totalTinTuc: number }> {
    let query = querystring.stringify({ page, pageSize, danhMucId })
    return axios
      .get(`${config.app.api}/api/tintuc/list?${query}`, axiosOptions)
      .then(response => {
        let danhSachTinTuc = response.data.tinTucList.map(t => {
          return new TinTuc(t)
        })
        let totalTinTuc = +response.data.totalTinTuc
        return {
          danhSachTinTuc,
          totalTinTuc,
        }
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }

  static getTinNoiBat(danhMucId, limit = 5): Promise<{ tinTuc: TinTucNew[] }> {
    let query = querystring.stringify({ limit, danhMucId })
    return axios
      .get(`${config.app.api}/api/tintuc/noi-bat?${query}`)
      .then(response => {
        let tinTuc: TinTucNew[] = response.data.tinTuc.map(t => new TinTucNew(t))
        return {
          tinTuc: tinTuc,
        }
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }
  /**xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx */


  static getTinTuc(page = 1, pageSize = 10) {
    let query = querystring.stringify({ page, pageSize, danhMucId: 150 })
    return axios
      .get(`${config.app.api}/api/tintuc/list?${query}`, axiosOptions)
      .then(response => {
        let danhSachTinTuc = response.data.tinTucList.map(t => {
          return new TinTuc(t)
        })
        let totalTinTuc = +response.data.totalTinTuc
        return {
          danhSachTinTuc,
          totalTinTuc,
        }
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }

  static getTinTucByDanhMuc(danhMucId, page = 1, pageSize = 10) {
    let query = querystring.stringify({
      page,
      pageSize,
      danh_muc_id: danhMucId,
    })
    return axios
      .get(`${config.app.api}/api/tintuc?${query}`, axiosOptions)
      .then(response => {
        let danhSachTinTuc = response.data.tinTucList.map(t => {
          t.danh_muc = t.danh_muc.map(d => new DanhMuc(d))
          return new TinTuc(t)
        })
        let totalTinTuc = +response.data.totalTinTuc
        let danhMuc = response.data.danhMuc
        return {
          danhSachTinTuc,
          totalTinTuc,
          danhMuc,
        }
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }

  static addComment(tinTucId, comment) {
    return axios
      .post(`${config.app.api}/api/tintuc/${tinTucId}/comment/add`, comment)
      .then(response => {
        return {
          tinTucId: tinTucId,
          comment: new Comment(response.data.comment),
        }
      })
  }

  static getTinLienQuan(tinTucId) {
    return axios
      .get(config.app.api + '/api/tintuc/getTinLienQuan', axiosOptions)
      .then(response => {
        return {
          tinTucId,
          cacTinTucLienQuan: response.data.map(tinTuc => {
            let comments = tinTuc.comment || []
            return {
              tinTuc: new TinTuc(tinTuc),
              comments: comments.map(comment => new Comment(comment)),
            }
          }),
        }
      })
  }

  static getTinTucChangePage(page, pageSize) {
    return TinTucService.getTinTuc()
  }

  /*
  lấy tin tức theo danh mục
  */
  static getsNewsByDanhMucID(
    danh_muc_id: number,
    limit: number = 10,
    page = 1
  ) {
    return axios
      .post(`${config.app.api}/api/tintuc/gets-by-danhmucid`, {
        danh_muc_id: danh_muc_id,
        per_page: limit,
        page: page,
      }, axiosOptions)
      .then(response => {
        return response.data
      })
  }

  /*
  lấy tin quan tâm
   */
  static getsTinQuanTam(limit) {
    return axios
      .post(`${config.app.api}/api/tintuc/gets-tin-quan-tam`, { limit: limit })
      .then(response => {
        return response.data.result
      })
  }

  /*
  lấy tin tức theo url
  */
  static getNewsByID = id => {
    let query = querystring.stringify({ id: id })
    return axios
      .get(`${config.app.api}/api/tintuc/get-news-by-id?${query}`, axiosOptions)
      .then(response => {
        if (!response.data.tinTuc) {
          return null
        }

        let comments = response.data.tinTuc.comment || []
        let tinTuc = response.data.tinTuc;
        tinTuc = new TinTuc(tinTuc);
        return {
          tinTuc: tinTuc,
          comments: comments.map(c => new Comment(c)),
          files: tinTuc.files,
        }
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }

  static getsNewsLienQuanByTinTucID = (tin_tuc_id: number, limit = 9) => {
    let query = querystring.stringify({ tin_tuc_id: tin_tuc_id, limit: limit })
    return axios
      .get(
        `${config.app.api}/api/tintuc/gets-news-lien-quan?${query}`,
        axiosOptions
      )
      .then(response => {
        let tinLienQuan = response.data.tinLienQuan || []
        return tinLienQuan.map(tinTuc => new TinQuanTam(tinTuc))
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }

  /*
  lấy tin dự án theo tag
  */
  static getsNewsDuAnByTag = (tag: string[], limit: number = 5) => {
    let body = {
      tag: tag,
      limit: limit,
    }
    return axios
      .post(
        `${config.app.api}/api/tintuc/gets-news-du-an-by-tag`,
        body,
        axiosOptions
      )
      .then(response => {
        return response.data
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }

  /*
 lấy tin tức theo tên tag
 */
  static searchNewsByTagString = (
    tag_string: string,
    limit: number = 10,
    page = 1
  ) => {
    let body = { tag_string: tag_string, per_page: limit, page: page }
    return axios
      .post(
        `${config.app.api}/api/tintuc/search-news-by-tag-string`,
        body,
        axiosOptions
      )
      .then(response => {
        return response.data
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }

  /**
   * get tin theo danh mucs
   */
  static getNewsByDanhMucs = (
    danh_mucs: number[],
    per_page: number = 10,
    page = 1
  ) => {
    let body = { danh_mucs: danh_mucs, per_page: per_page, page: page }
    return axios
      .post(
        `${config.app.api}/api/tintuc/gets-tin-by-danh-mucs`,
        body,
        axiosOptions
      )
      .then(response => {
        return response.data
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }


  /*
lấy tin tức theo tên tag
*/
  static searchNewsByTieuDe = (
    tieu_de: string,
    limit: number = 10,
    page = 1
  ) => {
    let body = { tieu_de: tieu_de, per_page: limit, page: page }
    return axios
      .post(
        `${config.app.api}/api/tintuc/search-news-by-tieu-de`,
        body,
        axiosOptions
      )
      .then(response => {
        return response.data
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }

  static getsNewsLienQuanByID = (tin_tuc_id: number, limit = 9) => {
    let query = querystring.stringify({ tin_tuc_id: tin_tuc_id, limit: limit })
    return axios
      .get(
        `${config.app.api}/api/tintuc/gets-news-lien-quan-by-id?${query}`,
        axiosOptions
      )
      .then(response => {
        let tinLienQuan = response.data.tinLienQuan || []
        return tinLienQuan.map(tinTuc => new TinQuanTam(tinTuc))
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }

}
